import { create } from "zustand";
import { helperTourSteps } from "@/config/helperTourStepsConfig";

export const useHelperTourStore = create((set, get) => ({
  isOpen: false,
  currentStepIndex: 0,
  steps: helperTourSteps,
  isCustomTour: false,

  startTour: () => {
    set({ isOpen: true, currentStepIndex: 0, isCustomTour: false });
  },

  startCustomTour: (customSteps) => {
    set({ steps: customSteps, isOpen: true, currentStepIndex: 0, isCustomTour: true });
  },

  nextStep: () => {
    const { currentStepIndex, steps } = get();
    if (currentStepIndex >= steps.length - 1) {
      set({ isOpen: false, currentStepIndex: 0, steps: helperTourSteps, isCustomTour: false });
      return;
    }
    set({ currentStepIndex: currentStepIndex + 1 });
  },

  prevStep: () => {
    const { currentStepIndex } = get();
    if (currentStepIndex <= 0) return;
    set({ currentStepIndex: currentStepIndex - 1 });
  },

  endTour: () => {
    set({ isOpen: false, currentStepIndex: 0, steps: helperTourSteps, isCustomTour: false });
  },
}));
